module.exports = __webpack_public_path__ + "media/images/index-hero-badge-en-120a7dc06c7a67baefde62d403cf1584.svg";